export const SortOrder = {
  ASCENDING: 'ASC',
  DESCENDING: 'DESC',
};

export const SortOrderEnum = {
  ASC: 'ASC',
  DESC: 'DESC',
};

export const SortState = {
  SORTED_ASCENDING: 'sorted ascending',
  SORTED_DESCENDING: 'sorted descending',
};

export const SortKey = {
  NEEDS_BY_DATE: 'needsByDate',
  SHIP_BY_DATE: 'shipByDate',
  PATIENT_NAME: 'patientName',
  PARTNER_NAME: 'partnerName',
  REQUESTED_DATE: 'requestedDate',
  STATUS: 'status',
  ON_BOARDED_DATE: 'onBoardedDate',
  ORDER_ID: 'orderId',
  ITEM_NAME: 'itemName',
  ORDER_STATUS: 'orderStatus',
  PARTNER_UUID: 'partnerUuid',
  MEDICATION: 'itemName',
  DOB: 'dob',
  DRUG_NAME: 'drugName',
  RX_NUMBER: 'rxNumber',
  REVIEW_STATUS: 'reviewStatus',
  MEDICATION_NAME: 'medicationName',
  PRACTICE_NAME: 'practiceName',
  SCRIPT_ID: 'scriptId',
  CREATED_AT: 'createdAt',
  DATE_RANGE: 'dateRange',
  REQUEST_STATUS: 'requestStatus',
  DOCUTRACK_ID: 'documentId',
  PARTNER_ACCOUNT: 'partnerAccount',
  FILL_TYPE: 'fillType',
  PARTNER_IDS: 'partnerIds',
  PRACTICE_IDS: 'practiceIds',
  TRACKING_NUMBER: 'trackingNumber',
  CARRIER_CODE: 'carrierCode',
  ORDER_NUMBER: 'orderNumber',
  SHIP_TO_NAME: 'shipToName',
  SKU: 'sku',
  SHIPPED_DATE: 'shippedDate',
  SERVICE_CODE: 'serviceCode',
  VOIDED: 'voided',
  SP_ORDER_ID: 'spOrderId',
  ADDRESS: 'address',
  ITEM_TYPE: 'itemType',
};

export const ProviderVerificationStatus = {
  VERIFIED: 'VERIFIED',
  UNVERIFIED: 'UNVERIFIED',
  FAILED: 'UNVERIFIED',
  NAME_MISMATCH: 'NAME_MISMATCH',
  PROVIDER_NPI_EXISTING_IN_SYSTEM: 'PROVIDER_NPI_EXISTING_IN_SYSTEM',
  PROVIDER_NPI_EXISTING_IN_PRACTICE: 'PROVIDER_NPI_EXISTING_IN_PRACTICE',
  NPI_INVALID: 'NPI_INVALID',
  FAILED_TO_VALIDATE: 'FAILED_TO_VALIDATE',
};

export const OrderFillType = {
  REFILL: 'REFILL',
  FIRST_FILL: 'FIRST_FILL',
};

export const ItemType = {
  RX: 'RX',
  OTC: 'OTC',
};

// POM-6330: how a queue's Tags filter matches — mirrors core's TagMatchMode.
export const TagMatchMode = {
  EXACT: 'EXACT',
  CONTAINS_ALL: 'CONTAINS_ALL',
};

export const OrderType = {
  RX_ENTRY: 'Rx Entry',
  OTC: 'OTC',
};

export const shipmentMode = {
  PRX_SHIPMENT: 'PRX_SHIPMENT',
  EXTERNAL_SHIPMENT: 'EXTERNAL_SHIPMENT',
  SHIP_VIA_SHIPSTATION: 'SHIP_VIA_SHIPSTATION',
};

export const ShipmentStatus = {
  REQUEST_CREATED: 'REQUEST_CREATED',
  REQUEST_SHIPPED: 'REQUEST_SHIPPED',
  VOIDED: 'VOIDED',
};

export const ServiceCodeEnum = {
  FEDEX_STANDARD_OVERNIGHT: 'FEDEX_STANDARD_OVERNIGHT',
  FEDEX_2DAY: 'FEDEX_2DAY',
  FEDEX_PRIORITY_OVERNIGHT: 'FEDEX_PRIORITY_OVERNIGHT',
};

export const PackageCodeEnum = {
  FEDEX_PAK: 'FEDEX_PAK',
  FEDEX_ONE_RATE: 'FEDEX_ONE_RATE',
  YOUR_PACKAGING: 'YOUR_PACKAGING',
};
